import typography from './typography';

export default { typography };
